import { SpecialCharacter } from "contract/common";

export const SPECIAL_CHARACTERS = {
  [SpecialCharacter.CELESTE]: {
    displayName: "character.Celeste",
    image: "/special-character/Celeste.png",
    role:
      "Celeste will randomly visit the player's island. During meteor showers, she will always be on the player's island watching the stars. She tells the player how to wish on shooting stars and gives the player recipes for the star wand and zodiac furniture. When presented with a Zodiac star fragment or Zodiac furniture, she will tell the player a mythological tale about the constellation.",
  },
  [SpecialCharacter.CJ]: {
    displayName: "character.CJ",
    image:
      "https://firebasestorage.googleapis.com/v0/b/turnips-exchange.appspot.com/o/assets%2Fcharacters%2FCJ.png?alt=media&token=b3ffdc04-9b4b-4a5c-a4d4-1ba47385515e",
    role:
      "During Fishing Tourneys or random visits, C.J. will buy fish from the player for 150% of their usual value. ",
  },
  [SpecialCharacter.DAISY_MAE]: {
    displayName: "character.DaisyMae",
    image:
      "https://firebasestorage.googleapis.com/v0/b/turnips-exchange.appspot.com/o/assets%2Fcharacters%2FDaisy%20Mae.png?alt=media&token=4dfdb21e-a8c8-4517-bfe4-b977247005e6",
    role:
      "Daisy Mae arrives at the player's island every Sunday morning (from 5 AM to 12 PM) to sell turnips at a specific price, taking on the role from her grandmother Joan. The turnips must then be sold before the next Sunday, or they will rot and lose all value.",
  },
  [SpecialCharacter.FLICK]: {
    displayName: "character.Flick",
    image:
      "https://firebasestorage.googleapis.com/v0/b/turnips-exchange.appspot.com/o/assets%2Fcharacters%2FFlick.png?alt=media&token=1dfe9feb-e5ef-4711-b9c4-77aba24f4a75",
    role:
      "During Bug Offs (which happen once every season i.e. spring, summer, winter etc.) or random visits, Flick will buy bugs from the player for 150% of their usual value. Flick is also an artist and the player can commission a model of a specific bug from him by bringing him three of the same bug; Flick will work on only one commission at a time, and mail it to the player the next day.",
  },
  [SpecialCharacter.KICKS]: {
    displayName: "character.Kicks",
    image: "/special-character/Kicks.png",
    role:
      "Kicks appears in the Resident Services plaza once per week as a traveling peddler after the player constructs the Able Sisters shop on their island. He sells shoes, socks, and bags, and offers his services from 5am to 10pm.",
  },
  [SpecialCharacter.LEIF]: {
    displayName: "character.Leif",
    image: "/special-character/Leif.png",
    role:
      "Leif sells a selection of shrubs and flower seeds that are not normally sold by Nook's Cranny. He also offers to buy weeds for 20 bells each, double the normal price.",
  },
  [SpecialCharacter.REDD]: {
    displayName: "character.Redd",
    image: "/special-character/Redd.png",
    role:
      "Redd runs his black market shop out of an old fishing boat called Jolly Redd's Treasure Trawler that anchors at the secret beach on the northern coast of the island.",
  },
  [SpecialCharacter.SAHARAH]: {
    displayName: "character.Saharah",
    image: "/special-character/Saharah.png",
    role:
      "Saharah makes her living selling rare and exotic carpets from faraway lands.",
  },
  [SpecialCharacter.TIMMY_AND_TOMMY]: {
    displayName: "character.TimmyTommy",
    image:
      "https://firebasestorage.googleapis.com/v0/b/turnips-exchange.appspot.com/o/assets%2Fcharacters%2FTimmy%20and%20Tommy.png?alt=media&token=770a693c-a582-4a77-8858-9db0706a8fc0",
    role:
      "Timmy and Tommy are both in the shop to buy and sell wares during their service hours of 8am to 10pm",
  },
};

export enum HELP_ARTICLE {
  AboutUs = "link-inc",
  Airport = "airport",
  BlockList = "block-list",
  CatalogScanner = "catalog-scanner",
  CommunityStandard = "community-standards",
  EULA = "eula",
  FlightCatalog = "catalog-and-wishlist",
  FlightChat = "flight-chat",
  FlightEntryFee = "flight-entry-fee",
  FlightMessage = "flight-message",
  FlightQueue = "flight-queue",
  FlightQueueList = "flightQueueList",
  FlightResident = "residents",
  FlightSpecialVisitor = "flightSpecialVisitor",
  FlightWishlist = "catalog-and-wishlist",
  ProfileCatalog = "catalog-and-wishlist",
  ProfileResident = "residents",
  ProfileVerification = "verification",
  ProfileMessage = "island-message",
  ProfileWishlist = "catalog-and-wishlist",
  Report = "report",
  SearchItem = "search-item",
  SearchVillager = "search-villager",
}

export const isDev =
  window.location.hostname === "localhost" ||
  window.location.hostname === "acnh-link-dev.web.app";
